<template>
  <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasUserMenu" aria-labelledby="offcanvasUserMenuLabel" v-swipe-left="closeMenu">
    <div class="offcanvas-header mt-1 pt-0 pb-0">
      <button type="button" class="btn btn-link btn-close-menu text-white" ref="menuCloseButton" data-bs-dismiss="offcanvas" aria-label="Закрыть">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <div class="offcanvas-menu-list">
        <ul class="list-unstyled" data-bs-dismiss="offcanvas">
          <li v-for="item in menuTop">
            <router-link class="menu-item" :class="{active: $route.path === item.link}" :to="item.link"><span>{{ item.name }}</span></router-link>
          </li>
        </ul>
      </div>
      <div class="offcanvas-menu-list-bottom">
        <div class="header text-secondary">Пока вы ждёте:</div>
        <ul class="list-unstyled" data-bs-dismiss="offcanvas">
          <li v-for="item in menuBottom">
            <router-link class="menu-item" :class="{active: $route.path === item.link}" :to="item.link"><span>{{ item.name }}</span></router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <nav class="navbar navbar-dark bg-black">
    <div class="container-fluid">
      <button class="navbar-toggler" type="button" ref="menuOpenButton" data-bs-toggle="offcanvas" href="#offcanvasUserMenu" role="button" aria-controls="offcanvasUserMenu">
        <span class="bi bi-list"></span>
      </button>
    </div>
  </nav>
</template>

<script>
import { UserModel } from "@/models/UserModel";

export default {
  computed: {
    menuTop() {
      const menuTopAuth = [
        {
          link: '/',
          name: 'Текущая смена',
          componentName: 'DashboardPage',
          keepAlive: true,
        },
        {
          link: '/archive',
          name: 'История смен',
          componentName: 'ArchivePage',
        },
        {
          link: '/settings',
          name: 'Настройки',
          componentName: 'SettingsPage',
        },
        // {
        //   link: '/chats',
        //   name: 'Чаты',
        //   keepAlive: true,
        //   componentName: 'ChatsPage',
        // },
        {
          link: '/logout',
          name: 'Выход',
        }
      ];
      const menuTopNotAuth = [
        {
          link: '/login',
          name: 'Авторизация',
          componentName: 'LoginPage',
        }
      ];
      return UserModel.isAuth() ? menuTopAuth : menuTopNotAuth;
    },
    menuBottom() {
      const menu = [
        {
          link: '/contacts',
          name: 'Написать разработчикам',
        },
        {
          link: '/check-updates',
          name: 'Проверить обновления',
          componentName: 'CheckUpdates',
        },
      ];
      if (UserModel.isTester()) {
        menu.push({
          link: '/tests',
          name: 'Тесты для разработчиков',
        });
      }
      return menu;
    }
  },
  methods: {
    openMenu() {
      this.$refs.menuOpenButton.click();
    },
    closeMenu() {
      this.$refs.menuCloseButton.click();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/scss/bootstrap-declaration.scss";
@import "@/styles/scss/bootstrap-overwrite.scss";

.navbar {
  z-index: 999;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.99);
  border-radius: 0 0 50% 0;
  position: fixed;
  top: 0;
  left: 0;
  //left: -1000px;

  .navbar-toggler {
    box-shadow: none !important;
    border: none;
    padding-left: 0;
    padding-right: 0;
    font-size: 36px;
    color: #FFF;
  }
}

.offcanvas {
  background: #111;

  .btn-close-menu {
    font-size: 28px;
    margin-top: 5px;
    margin-bottom: 5px;
    padding: 0;
  }

  &-menu-list-bottom {
    margin-bottom: 60px; // Смещение чтобы bottom-menu приклеенное к низу приложение не закрывало это меню
  }

  .menu-item {
    color: #FFF;
    padding: 10px 0;
    margin: 10px 0;
    white-space: nowrap;
    display: block;
    width: 100%;
    text-align: left;
    text-decoration: none;

    &.active {
      color: $primary;
    }
  }

  .header {
    border-bottom: 1px solid;
    margin-bottom: 15px;
    white-space: nowrap;
    display: inline-block;
  }

  .offcanvas-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>